import axios from 'axios'

// A forward (phone or email) that another user on the property already
// subscribes to is the one provisioning refusal an operator can fix without
// leaving the panel, so it has to be told apart from every other 422. The
// server reports it as an Ecto unique-constraint violation on the
// `alert_target` changeset, which JaSerializer renders as a JSON:API error
// pointing at that field.
export function isDuplicateAlertTargetError(error: unknown): boolean {
  if (!axios.isAxiosError(error) || error.response?.status !== 422) return false

  const errors: any[] = error.response?.data?.errors ?? []
  return errors.some(e => {
    const pointer = String(e?.source?.pointer ?? '')
    const message = `${e?.title ?? ''} ${e?.detail ?? ''}`.toLowerCase()
    return /alert[-_]target/i.test(pointer) || (message.includes('forward') && message.includes('already exists'))
  })
}
